import React from "react";
import { Grid, Icon, IconButton, MenuItem, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { FieldArray } from "formik";
import { useMaterialUIController } from "context";

// mask function
const maskCep = (value) => {
    let r = value.replace(/\D/g, "");
    if (r.length > 8) r = r.slice(0, 8);
    if (r.length > 5) r = r.replace(/^(\d{5})(\d{1,3})/, "$1-$2");
    return r;
};

export default function DevedorEnderecoSection({ values, setFieldValue, handleChange, isViewOnly }) {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const handleCepSearch = async (index, cepValue) => {
        const masked = maskCep(cepValue);
        setFieldValue(`enderecos[${index}].ccCep`, masked);
        
        const cleanCep = masked.replace(/\D/g, '');
        if (cleanCep.length === 8) {
            try {
                const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);
                const data = await response.json();
                if (!data.erro) {
                    setFieldValue(`enderecos[${index}].ccLogradouro`, data.logradouro || '');
                    setFieldValue(`enderecos[${index}].ccBairro`, data.bairro || '');
                    setFieldValue(`enderecos[${index}].ccCidade`, data.localidade || '');
                    setFieldValue(`enderecos[${index}].ccEstado`, data.uf || '');
                }
            } catch (error) {
                console.error("Erro ao buscar CEP", error);
            }
        }
    };

    return (
        <MDBox mt={2}>
            <FieldArray name="enderecos">
                {({ push, remove }) => (
                    <>
                        <MDBox display="flex" justifyContent="flex-end" mb={1}>
                            <MDButton variant="contained" color="info" size="small" onClick={() => push({ ccCep: '', ccLogradouro: '', ccNumero: '', ccComplemento: '', ccBairro: '', ccCidade: '', ccEstado: '', cvTipo: 1, cvOrigem: 1, cbRuim: false })}>
                                <Icon sx={{ mr: 0.5 }}>add</Icon> Adicionar Endereço
                            </MDButton>
                        </MDBox>

                        {values.enderecos.length > 0 && (
                            <MDBox sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                {values.enderecos.map((item, index) => (
                                    <MDBox key={index} sx={{ py: 2, px: 1, borderBottom: "1px solid", borderColor: "divider" }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={2}>
                                                <MDInput 
                                                    fullWidth 
                                                    size="small"
                                                    label="CEP"
                                                    name={`enderecos[${index}].ccCep`}
                                                    value={item.ccCep} 
                                                    onChange={(e) => handleCepSearch(index, e.target.value)} 
                                                    autoComplete="off"

                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={5}>
                                                <MDInput 
                                                    fullWidth 
                                                    size="small"
                                                    label="Logradouro"
                                                    name={`enderecos[${index}].ccLogradouro`}
                                                    value={item.ccLogradouro} 
                                                    onChange={handleChange} 
                                                    autoComplete="off"

                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <MDInput 
                                                    fullWidth 
                                                    size="small"
                                                    label="Número"
                                                    name={`enderecos[${index}].ccNumero`}
                                                    value={item.ccNumero} 
                                                    onChange={handleChange} 
                                                    autoComplete="off"

                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={3}>
                                                <MDInput 
                                                    fullWidth 
                                                    size="small"
                                                    label="Complemento"
                                                    name={`enderecos[${index}].ccComplemento`}
                                                    value={item.ccComplemento} 
                                                    onChange={handleChange} 
                                                    autoComplete="off"

                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <MDInput 
                                                    fullWidth 
                                                    size="small"
                                                    label="Bairro"
                                                    name={`enderecos[${index}].ccBairro`}
                                                    value={item.ccBairro} 
                                                    onChange={handleChange} 
                                                    autoComplete="off"

                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={3}>
                                                <MDInput 
                                                    fullWidth 
                                                    size="small"
                                                    label="Cidade"
                                                    name={`enderecos[${index}].ccCidade`}
                                                    value={item.ccCidade} 
                                                    onChange={handleChange} 
                                                    autoComplete="off"

                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={1}>
                                                <MDInput 
                                                    fullWidth 
                                                    size="small"
                                                    label="UF"
                                                    name={`enderecos[${index}].ccEstado`}
                                                    value={item.ccEstado} 
                                                    onChange={handleChange} 
                                                    autoComplete="off"

                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <MDInput 
                                                    select 
                                                    fullWidth 
                                                    size="small"
                                                    label="Tipo"
                                                    name={`enderecos[${index}].cvTipo`}
                                                    value={item.cvTipo} 
                                                    onChange={handleChange}

                                                >
                                                    <MenuItem value={1}>Residencial</MenuItem>
                                                    <MenuItem value={2}>Comercial</MenuItem>
                                                </MDInput>
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <MDInput 
                                                    select 
                                                    fullWidth 
                                                    size="small"
                                                    label="Origem"
                                                    name={`enderecos[${index}].cvOrigem`}
                                                    value={item.cvOrigem} 
                                                    onChange={handleChange}

                                                >
                                                    <MenuItem value={1}>Serasa</MenuItem>
                                                    <MenuItem value={2}>Boa Vista</MenuItem>
                                                    <MenuItem value={3}>Cliente</MenuItem>
                                                    <MenuItem value={4}>Informado</MenuItem>
                                                    <MenuItem value={5}>Outros</MenuItem>
                                                    <MenuItem value={6}>Remessa</MenuItem>
                                                </MDInput>
                                            </Grid>
                                            <Grid item xs={12} sm={12} display="flex" alignItems="center" justifyContent="flex-end" gap={3}>
                                                <MDBox display="flex" alignItems="center">
                                                    <MDTypography variant="caption" mr={1}>Endereço Ruim?</MDTypography>
                                                    <Switch 
                                                        checked={item.cbRuim} 
                                                        onChange={(e) => setFieldValue(`enderecos[${index}].cbRuim`, e.target.checked)} 
                                                    />
                                                </MDBox>
                                                
                                                <Tooltip title="Remover Endereço">
                                                    <MDButton variant="outlined" color="error" size="small" onClick={() => remove(index)}>
                                                        <Icon sx={{ mr: 0.5 }}>delete</Icon> Remover
                                                    </MDButton>
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                ))}
                            </MDBox>
                        )}
                    </>
                )}
            </FieldArray>
        </MDBox>
    );
}
